module.exports = __webpack_public_path__ + "img/sfks-3.50cf31a0.jpg";